export default __webpack_public_path__ + "static/media/6.03e135da.svg";